import React from "react";
import { NotepadText, MapPin, Users, Award, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./Home.module.css";
import { Download } from "lucide-react";

export default function Home() {
  return (
    <div>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>ICETMCP-2026</h1>
          <h2 className={styles.heroSubtitle}>
            International Conference on Emerging Trends in
            <br />
            Machine Learning, Computer Vision, and Pattern Recognition
          </h2>
          <p className={styles.heroDescription1}>
            Idhaya Engineering College for Women in Association with Genesys
            Academy
          </p>
          <div className={styles.heroActions}>
            <Link to="/landingpage/submission" className={styles.btnAccent}>
              <span>Submit Paper</span>
              <ArrowRight size={16} style={{ marginLeft: "8px" }} />
            </Link>
            <Link
              to="/landingpage/registration"
              className={styles.btnSecondary}
            >
              Register Now
            </Link>
            {/* <a
    href="/assets/Proceedings.pdf"
    className={`${styles.btnSecondary} ${styles.highlightButton}`}
    download
  >
    <Download size={16} style={{ marginRight: "8px" }} />
    Download Proceedings
  </a> */}
          </div>
        </div>
      </section>

      {/* Conference Overview */}
      <section className={styles.aboutSection}>
        <div className={styles.container}>
          <div className={styles.aboutContent}>
            <div>
              <h1 className={styles.sectionTitle}>About the Conference</h1>
              <p className={styles.aboutText}>
                <b>The International Conference on Emerging Trends in Machine
                Learning, Computer Vision, and Pattern Recognition
                (ICETMCP-2026) Edition 2 </b> aims to bring together leading researchers,
                academicians, industry experts, and practitioners to discuss the
                latest advancements and innovative solutions in the fields of
                artificial intelligence and computer vision. The conference will
                serve as a premier platform for presenting cutting-edge
                researches, sharing novel methodologies, and exploring practical
                applications across diverse domains. Machine Learning track will
                cover advances in algorithms, optimization techniques,
                generative models, and intelligent systems that enable
                data-driven decision-making in diverse fields such as
                healthcare, finance, autonomous systems, etc. In the Computer
                Vision track, the conference will focus on advancements in image
                and video analysis, object detection, scene understanding,
                visual recognition, augmented reality, and multimodal sensor
                integration. The Pattern Recognition track will emphasize
                intelligent data analytics, signal processing, feature
                extraction, and classification techniques, addressing challenges
                in high-dimensional data, temporal patterns, and multimodal
                fusion.
              </p>
              <p className={styles.aboutText}>
                The conference will feature keynote discussion with renowned
                experts, technical paper presentations, and collaborative
                debates, providing participants with opportunities for knowledge
                exchange and collaboration. By fostering interdisciplinary
                research and innovative solutions, ICETMCP-2026 Edition 2 aims to advance
                the state-of-the-art in AI-driven technologies and their
                practical applications, bridging the gap between theory and
                industry implementation.
              </p>
            </div>
          </div>

          {/* Conference Highlights */}
          <section className={styles.conference}>
            <div>
              <h1
                className={styles.conferenceTitle}
                style={{ textAlign: "left", marginBottom: "24px" }}
              >
                Conference Highlights
              </h1>
            </div>
            <div className={styles.featuresGrid}>
              <div className={styles.div1}>
                <div className={styles.featureCard}>
                  <Award
                    size={48}
                    className={styles.featureIcon}
                    style={{ color: "#0d9488" }}
                  />
                  <h3 className={styles.featureTitle}>
                    Peer Reviewed Publications
                  </h3>
                  <p className={styles.featureDescription}>
                    All accepted papers will be included in conference
                    proceedings with ISBN (978-81-991869-0-3). Selected
                    papers will be published in scopus indexed journals as per journal guidelines.
                  </p>
                </div>
                <div className={styles.featureCard}>
                  <MapPin
                    size={48}
                    className={styles.featureIcon}
                    style={{ color: "#ea580c" }}
                  />
                  <h3 className={styles.featureTitle}>Presentation Mode</h3>
                  <p className={styles.featureDescription}>
                    Present your research in a hybrid mode, online via Google
                    Meet/Zoom.
                  </p>
                </div>
              </div>
              <div className={styles.div2}>
                <div className={styles.featureCard}>
                  <Users
                    size={48}
                    className={styles.featureIcon}
                    style={{ color: "#3b82f6" }}
                  />
                  <h3 className={styles.featureTitle}>
                    Networking Opportunities
                  </h3>
                  <p className={styles.featureDescription}>
                    Connect with researchers and industry professionals
                    worldwide.
                  </p>
                </div>
                <div className={styles.featureCard}>
                  <NotepadText
                    size={48}
                    className={styles.featureIcon}
                    style={{ color: "#16a34a" }}
                  />
                  <h3 className={styles.featureTitle}>Diverse Topics</h3>
                  <p className={styles.featureDescription}>
                    Covering Machine Learning, Computer Vision, Pattern
                    Recognition and its applications.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Call to Action */}
      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <h2 className={styles.ctaTitle}>Ready to Share Your Research?</h2>
          <p className={styles.ctaDescription}>
            Submit your original research contributions and join the global
            community of researchers
          </p>
          <div className={styles.ctaActions}>
            <Link to="/landingpage/submission" className={styles.btnAccent}>
              View Submission Guidelines
            </Link>
            <Link
              to="/landingpage/registration"
              className={styles.btnSecondary}
            >
              Register for Conference
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
